module.exports = __webpack_public_path__ + "img/gala-profile-banner.d68dcd2.png";